if (!customElements.get('show-more-button')) {
  class ShowMoreButton extends HTMLElement {
    constructor() {
      super();
      const button = this.querySelector('button');
      button.addEventListener('click', (event) => {
        this.expandShowMore(event);
        const nextElementToFocus = event.target.closest('.parent-display').querySelector('.show-more-item');
        if (nextElementToFocus && !nextElementToFocus.classList.contains('hidden') && nextElementToFocus.querySelector('input')) {
          nextElementToFocus.querySelector('input').focus();
        }
      });
    }
    expandShowMore(event) {
      const parentDisplay = event.target.closest('[id^="Show-More-"]').closest('.parent-display');
      const parentWrap = parentDisplay.querySelector('.parent-wrap');
      this.querySelectorAll('.label-text').forEach((element) => element.classList.toggle('hidden'));
      parentDisplay.querySelectorAll('.show-more-item').forEach((item) => item.classList.toggle('hidden'));
      if (!this.querySelector('.label-show-less')) {
        this.classList.add('hidden');
      }
    }
  }

  customElements.define('show-more-button', ShowMoreButton);

  class ReadMoreButton extends ShowMoreButton {
    constructor() {
      super();
      this.nRows = this.getAttribute('n-rows');
      this.showMoreItem = this.closest('.parent-display').querySelector('.show-more-item');
      this.showReadMoreButton();
    }
    expandShowMore(event) {
      const parentDisplay = event.target.closest('[id^="Show-More-"]').closest('.parent-display');
      this.querySelectorAll('.label-text').forEach((element) => element.classList.toggle('hidden'));
      parentDisplay.querySelectorAll('.show-more-item').forEach((item) => item.classList.toggle('read-more'));
      if (!this.querySelector('.label-show-less')) {
        this.classList.add('hidden');
      }
    }
    checkTextHeightInLines() {
      const lineHeight = parseInt(window.getComputedStyle(this.showMoreItem).lineHeight, 10);
      const totalHeight = this.showMoreItem.scrollHeight;
      const numberOfLines = Math.ceil(totalHeight / lineHeight);

      return numberOfLines > this.nRows;
    }
    showReadMoreButton() {
      this.checkTextHeightInLines() ? this.classList.remove('hidden') : this.classList.add('hidden');
    }
  }

  customElements.define('read-more-button', ReadMoreButton);
}
